import React from "react";
import CrmTiles from "./crmTiles";
import { ApiHook } from "../../hooks/apiHook";

const CrmTilesSegment = ({tiles}) => {
  //----------------------------------------- API ---------------------------------------

  
  return (
    <div className="crm-con-sec">
      <div className="row">
        <CrmTiles
          text={"prospepcting"}
          count={tiles.data?.crmTiles?.prospecting ?? 0}
        />
        <CrmTiles
          text={"sheduled_presetantions"}
          count={tiles.data?.crmTiles?.scheduldPresetations ?? 0}
        />
        <CrmTiles
          text={"efffective_presentations"}
          count={tiles.data?.crmTiles?.EffectivePresentations ?? 0}
        />
          <CrmTiles
          text={"sheducled_project_visits"}
          count={tiles.data?.crmTiles?.SheduledProjectVisits ?? 0}
        />
      </div>
       <div className="row mt-2" >
        <CrmTiles
          text={"effective_project_visits"}
          count={tiles.data?.crmTiles?.EffectiveProjectVisits ?? 0}
        />
        <CrmTiles
          text={"amount_deposits"}
          count={tiles.data?.crmTiles?.AmountDeposits ?? 0}
        />
        <CrmTiles
          text={"amount_of_initail_payments"}
          count={tiles.data?.crmTiles?.AmountOfInitailPayments ?? 0}
        />
     
      </div>
    </div>
  );
};

export default CrmTilesSegment;
